module.exports = __webpack_public_path__ + "media/v2/person-bottom-43dfd2a9.png";